import { createCollectionLink } from "@/router";
import { RouteName } from "@/router/routeNameEnum";
import { type CollectionItem_ListItem, ItemStatus } from "@/services/collection/item";
import type { Image } from "@/services/images";
import { factoryImage } from "@/services/images";
import { Filter } from "@/services/collection/collectionFilter";
import { ItemStatusUrlString } from "@/services/collection/collectionUrl";
import type { RouteLocationNormalized } from "vue-router";

export const getCoverImage = (item: CollectionItem_ListItem): Image | undefined => {
  const img = item.images.length > 0 ? item.images[0] : undefined;
  if (img) {
    return factoryImage(img.id, img.imageUrl, item.name);
  } else {
    return undefined;
  }
};

export const createArchiveLink = () => {
  const filter = new Filter({ itemStatus: ItemStatus.Archived });
  return createCollectionLink(filter);
};

export const createMyCollectionMarketplaceItemsLink = () => {
  const filter = new Filter({ itemStatus: ItemStatus.OnMarketplace });
  return createCollectionLink(filter);
};

export const createMyCollectionLink = () => {
  const filter = new Filter({ itemStatus: ItemStatus.InMyCollection });
  return createCollectionLink(filter);
};

export const isArchiveRoute = (route: RouteLocationNormalized): boolean => {
  const isCollectionRoute = route.name === RouteName.Collection;
  const isArchiveFilter = route.params.itemStatus === ItemStatusUrlString.Archived;
  return isCollectionRoute && isArchiveFilter;
};

export const isPublic = (item: CollectionItem_ListItem): boolean => {
  return item.userCollectionList.length > 0;
};
